import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

export interface ChartFrameProps {
  title?: string;
  subtitle?: string;
  headerActions?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** Shared chrome wrapper (card outline, title, subtitle) for all chart types. */
export const ChartFrame = ({
  title,
  subtitle,
  headerActions,
  className,
  children,
}: ChartFrameProps) => (
  <div
    className={twMerge(
      'bg-white border border-navy-200 rounded-lg pt-3.5 px-5 pb-4',
      className
    )}
  >
    {(title || subtitle || headerActions) && (
      <div className="flex items-start justify-between gap-3">
        <div>
          {title && (
            <h3 className="font-text text-xl font-bold text-gray-800 m-0">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="font-text font-normal text-gray-500 m-0">{subtitle}</p>
          )}
        </div>
        {headerActions}
      </div>
    )}
    {children}
  </div>
);
